import React, { ComponentProps, forwardRef } from 'react';
import styled from 'styled-components';

import { sizedIcon } from './icon.style';

const DEFAULT_ICON_SIZE = '1em';

export type IconProps = ComponentProps<'svg'> & {
  size?: number | string;
  icon: React.FunctionComponent<React.SVGProps<SVGSVGElement>>;
};

const IconBase = forwardRef<SVGSVGElement, IconProps>(
  ({ size, icon: IconComponent, className, ...props }, ref) => (
    <IconComponent
      ref={ref}
      className={className}
      width={size ?? DEFAULT_ICON_SIZE}
      height={size ?? DEFAULT_ICON_SIZE}
      {...props}
    />
  ),
);

export const Icon = styled(IconBase)`
  ${({ size }) => size !== undefined && sizedIcon};
`;
